(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcementbar-one"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-ab-slider]';

    function AnnouncementSlider(root) {
      this.root = root;
      this.slides = Array.prototype.slice.call(
        root.querySelectorAll('[data-ab-slide]')
      );
      this.liveRegion = root.querySelector('[data-ab-live]');
      this.interval = parseInt(root.getAttribute('data-interval'), 10) || 3500;
      this.currentIndex = this.slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.timer = null;
      this.start();
    }

    AnnouncementSlider.prototype.start = function () {
      if (this.slides.length < 2) return;
      this.stop();
      var self = this;
      this.timer = window.setInterval(function () {
        self.next();
      }, this.interval);
    };

    AnnouncementSlider.prototype.stop = function () {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    };

    AnnouncementSlider.prototype.next = function () {
      var current = this.slides[this.currentIndex];
      var nextIndex = (this.currentIndex + 1) % this.slides.length;
      var next = this.slides[nextIndex];
      if (!current || !next || current === next) return;

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');

      next.style.transition = 'none';
      next.style.transform = 'translateX(100%)';
      next.getBoundingClientRect();
      next.style.transition = '';
      next.style.transform = '';
      next.classList.add('is-active');
      next.setAttribute('aria-hidden', 'false');

      if (this.liveRegion) {
        this.liveRegion.textContent = next.textContent.trim();
      }

      var self = this;
      window.setTimeout(function () {
        current.classList.remove('is-leaving');
      }, 650);

      this.currentIndex = nextIndex;
    };

    AnnouncementSlider.prototype.destroy = function () {
      this.stop();
    };

    function initAll(scope) {
      var sliders = Array.prototype.slice.call(
        (scope || document).querySelectorAll(SELECTOR)
      );
      sliders.forEach(function (root) {
        if (root._abSlider) root._abSlider.destroy();
        root._abSlider = new AnnouncementSlider(root);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector
        ? event.target.querySelector(SELECTOR)
        : null;
      if (root && root._abSlider) root._abSlider.destroy();
    });

    document.addEventListener('shopify:section:select', function (event) {
      var root = event.target.querySelector
        ? event.target.querySelector(SELECTOR)
        : null;
      if (root && root._abSlider) root._abSlider.stop();
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      var root = event.target.querySelector
        ? event.target.querySelector(SELECTOR)
        : null;
      if (root && root._abSlider) root._abSlider.start();
    });

    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest ? event.target.closest(SELECTOR) : null;
      if (!root || !root._abSlider) return;
      var slide = event.target;
      var index = parseInt(slide.getAttribute('data-index'), 10);
      if (isNaN(index)) return;
      root._abSlider.stop();
      root._abSlider.slides.forEach(function (s) {
        s.classList.remove('is-active', 'is-leaving');
        s.style.transform = '';
        s.setAttribute('aria-hidden', 'true');
      });
      slide.classList.add('is-active');
      slide.setAttribute('aria-hidden', 'false');
      root._abSlider.currentIndex = index;
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var root = event.target.closest ? event.target.closest(SELECTOR) : null;
      if (root && root._abSlider) root._abSlider.start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
